import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function AppDeleteRequestsPage() {
  const nav = useNavigate();

  const [requests, setRequests] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");
  const [processingId, setProcessingId] = useState(null);

  const loadRequests = async () => {
    setLoading(true);
    setErr("");

    try {
      const res = await authFetch(
        `${API_URL}/api/clienti/app-delete-requests/`
      );

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(
          data?.detail || "Errore caricamento richieste."
        );
      }

      setRequests(Array.isArray(data?.results) ? data.results : []);
      setPendingCount(Number(data?.pending_count || 0));
    } catch (e) {
      setErr(e?.message || "Errore caricamento richieste.");
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRequests();
  }, []);

  const processRequest = async (id, action) => {
    const isComplete = action === "complete";

    const ok = window.confirm(
      isComplete
        ? "Confermi la chiusura definitiva dell'account App di questo cliente?"
        : "Confermi il rifiuto della richiesta? L'account rester? attivo."
    );

    if (!ok) return;

    setProcessingId(id);
    setErr("");
    setMsg("");

    try {
      const res = await authFetch(
        `${API_URL}/api/clienti/app-delete-requests/${id}/action/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ action }),
        }
      );

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(
          data?.detail || "Errore durante l'elaborazione della richiesta."
        );
      }

      setMsg(data?.detail || "Richiesta elaborata correttamente.");
      await loadRequests();
    } catch (e) {
      setErr(
        e?.message ||
          "Errore durante l'elaborazione della richiesta."
      );
    } finally {
      setProcessingId(null);
    }
  };

  const statusBadge = (status) => {
    if (status === "COMPLETED") {
      return <span className="badge text-bg-success rounded-pill">Completata</span>;
    }

    if (status === "REJECTED") {
      return <span className="badge text-bg-secondary rounded-pill">Rifiutata</span>;
    }

    return <span className="badge text-bg-danger rounded-pill">In attesa</span>;
  };

  return (
    <div className="container py-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
        <div>
          <div className="text-muted small text-uppercase fw-semibold">
            Gestione App Clienti
          </div>

          <h1 className="fw-bold mb-1">
            Richieste eliminazione account
          </h1>

          <div className="text-muted">
            Gestisci le richieste inviate direttamente dai clienti tramite App.
          </div>
        </div>

        <button
          type="button"
          className="btn btn-outline-secondary rounded-pill px-4"
          onClick={() => nav("/gestione-app-clienti")}
        >
          Torna a Gestione App Clienti
        </button>
      </div>

      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body p-4 d-flex justify-content-between align-items-center">
          <div>
            <div className="text-muted small">Richieste in attesa</div>
            <div className="display-6 fw-bold">{pendingCount}</div>
          </div>

          <div
            className="fw-bold"
            style={{
              fontSize: 18,
              color: "#dc3545",
              border: "2px solid #dc3545",
              borderRadius: 14,
              padding: "10px 14px",
            }}
          >
            DELETE
          </div>
        </div>
      </div>

      {err && (
        <div className="alert alert-danger rounded-4">{err}</div>
      )}

      {msg && (
        <div className="alert alert-success rounded-4">{msg}</div>
      )}

      {loading ? (
        <div className="alert alert-light border rounded-4">
          Caricamento richieste...
        </div>
      ) : requests.length === 0 ? (
        <div className="alert alert-light border rounded-4">
          Nessuna richiesta presente.
        </div>
      ) : (
        <div className="card border-0 shadow-sm rounded-4">
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Email</th>
                    <th>Codice</th>
                    <th>Data richiesta</th>
                    <th>Stato</th>
                    <th className="text-end">Azioni</th>
                  </tr>
                </thead>

                <tbody>
                  {requests.map((r) => {
                    const c = r.client || {};
                    const pending = r.status === "PENDING";

                    return (
                      <tr key={r.id}>
                        <td className="fw-semibold">
                          {`${c.first_name || ""} ${c.last_name || ""}`.trim() || "-"}
                        </td>

                        <td>{c.email || "-"}</td>

                        <td>{c.code || "-"}</td>

                        <td>
                          {r.requested_at
                            ? new Date(r.requested_at).toLocaleString("it-IT")
                            : "-"}
                        </td>

                        <td>{statusBadge(r.status)}</td>

                        <td className="text-end">
                          {pending ? (
                            <div className="d-flex justify-content-end flex-wrap gap-2">
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm rounded-pill"
                                disabled={processingId === r.id}
                                onClick={() => processRequest(r.id, "reject")}
                              >
                                Rifiuta
                              </button>

                              <button
                                type="button"
                                className="btn btn-danger btn-sm rounded-pill"
                                disabled={processingId === r.id}
                                onClick={() => processRequest(r.id, "complete")}
                              >
                                Chiudi account
                              </button>
                            </div>
                          ) : (
                            <span className="text-muted small">
                              Completata
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
